import React from "react"
import { useParams } from "react-router-dom";


const Bottom=(props)=>{
    //console.log("props---Bottom------>",props)
    const {slot_id} =useParams()
    const {machine_id} =useParams()

//console.log("khan props bottom",props.props.productDetailsData&&props.props.productDetailsData.activeCount)

const mvIdToFind = props&&props.props&&props.props.productDetailsData&&props.props.productDetailsData.slotId; // Replace with the ID you want to search for
const foundItem =props&&props.props&&props.props.cartItemsList&&props.props.cartItemsList.find(item => item.slotId === mvIdToFind);

//console.log("khan foundItem",foundItem)
//console.log("khan foundItem----",mvIdToFind)
const RemoveToCartFromBottom=(e,slotid,count)=>{
const machineId=localStorage.getItem("machineId")
    props&&props.props&&props.props.RemovefromCart(e,slotid,count,machineId)

}

const addToCartFromBottom=(e,index,slotid,count)=>{
    //console.log("khan slotid,count,machine_id",slotid,count,machine_id)
    const machineId=localStorage.getItem("machineId")

        props&&props.props&&props.props.AddIntoCart({e,i:index,sId:slotid,myCartcount:count,machine_id:machine_id,replace:false})
    
    }

  function calculateFinalPrice(item) {
  const mvOfferPrice = item?.mvOfferPrice || 0;
  const offerDetails = item?.offer_details;


  
  // ❌ No offer OR not a Discount coupon
  if (!offerDetails || offerDetails.couponType !== "Discount") {
    return mvOfferPrice;
  }

  const { flatTypeId, flatAmount } = offerDetails;

  let discount = 0;

  if (flatTypeId === 1) {
    // Flat amount (₹)
    discount = flatAmount || 0;
  } else if (flatTypeId === 2) {
    // Percentage (%)
    discount = (mvOfferPrice * (flatAmount || 0)) / 100;
  }

  const finalPrice = mvOfferPrice - discount;

  return Math.max(finalPrice, 0);
}


   return(
    
    <>
    
    <div style={{position:"fixed", bottom:"0px",background:"white",height:props&&props.props&&props.props.cartItemsList&&props&&props.props&&props.props.cartItemsList[0]&&props?.props?.productDetailsData?.isSample==true?"":props.props&&props.props.cartItemsList[0]?"141px":"100px",width:"100vw",}}>
        <hr/>
        <div style={{display:"flex",justifyContent:"space-between",    padding: "5vw"}}>
        <div>
        <p className="bottomData" style={{fontWeight:"500",fontSize:"12px",padding:"1vw",color:" #757575"}}>{props&&props.props&&props.props.productDetailsData&&props.props.productDetailsData.product_details.packageWeight}{" "}{props&&props.props&&props.props.productDetailsData&&props.props.productDetailsData.product_details.quantityType}</p>
        <p className="bottomData"style={{fontWeight:"600",fontSize:"14px",padding:"1vw",color: "#384F6F"}} >                     ₹{props?.props?.productDetailsData?.isSample==true?calculateFinalPrice(props?.props?.productDetailsData).toFixed(2):props?.props?.productDetailsData?.mvOfferPrice.toFixed(2) }</p>
        <p className="bottomData"style={{fontWeight:"400",fontSize:"12px",padding:"1vw",color: "#94A3B8"}} >Inclusive of all taxes</p>
        </div>
        <div>
            {props&&props.props&&props.props.cartItemsList&&props.props.cartItemsList.length<0?


<>           
            <div style={{    display: "flex",alignItems:"center",color: "#129A69",

    justifyContent: "center",height:"13vw",width:"30vw",background:" #00B1770A",border: "1px solid #129A69",borderRadius:"8px"}}>
            Notify Me
            </div>

            </>
            
            
            
            :
            <>
        {/*     {console.log("khan foundItem",foundItem)
            } */}
            {foundItem&&foundItem?

            <div  style={{    color:"white",background: "#129A69",display: "flex",alignItems:"center",display: "flex",justifyContent:"space-around",

justifyContent: "center",height:"13vw",width:"30vw",border: "1px solid #129A69",borderRadius:"8px",    justifyContent: "space-around"}}>
      <span onClick={(e)=>{RemoveToCartFromBottom(e,foundItem.slotId,foundItem.count)}} >-</span>{foundItem&&foundItem.count}<span onClick={(e)=>{addToCartFromBottom(e,1,foundItem.slotId,foundItem.count,machine_id)}}>+</span>
        </div>
        
        :  
        <div>
            {props&&props.props&&props.props.productDetailsData&&props.props.productDetailsData.activeCount>0?
        
        <div  onClick={(e)=>{addToCartFromBottom(e,0,slot_id,0,machine_id)}} style={{    color:"white",background: "#129A69",display: "flex",alignItems:"center",display: "flex",justifyContent:"space-around",

justifyContent: "center",height:"13vw",width:"30vw",border: "1px solid #129A69",borderRadius:"8px",    justifyContent: "space-around"}}>
     ADD
        </div>:    <div style={{    color:"white",background: "rgb(127 134 132)",display: "flex",alignItems:"center",display: "flex",justifyContent:"space-around",

justifyContent: "center",height:"13vw",width:"30vw",borderRadius:"8px",    justifyContent: "space-around"}}>
     ADD
        </div>}
        </div>
}
        </>
        }
        </div>

        </div>

    </div>
    
    
    </>)
}

export default Bottom